import { render } from "./fncAthdc.vue?vue&type=template&id=5b4dff74&scoped=true"
import script from "./fncAthdc.vue?vue&type=script&lang=js"
export * from "./fncAthdc.vue?vue&type=script&lang=js"

import "./fncAthdc.vue?vue&type=style&index=0&id=5b4dff74&scoped=true&lang=css"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4dff74"]])

export default __exports__